import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { apiFetch } from "@/lib/api";
import { ListingForm } from "@/components/ListingForm";
import { PageLoader, ErrorState } from "@/components/common";

export default function EditListing() {
  const { id } = useParams();
  const navigate = useNavigate();
  const qc = useQueryClient();

  const { data: listing, isLoading, isError, refetch } = useQuery({
    queryKey: ["listing", id],
    queryFn: () => apiFetch(`/listings/${id}`),
  });

  const update = async (payload) => {
    await apiFetch(`/listings/${id}`, { method: "PUT", body: JSON.stringify(payload) });
    qc.invalidateQueries({ queryKey: ["listing", id] });
    qc.invalidateQueries({ queryKey: ["my-listings"] });
    qc.invalidateQueries({ queryKey: ["listings"] });
    toast.success("Listing updated");
    navigate(`/listing/${id}`);
  };

  if (isLoading) return <PageLoader />;
  if (isError) return <ErrorState onRetry={refetch} />;

  return (
    <div className="mx-auto max-w-2xl px-4 py-8 sm:px-6">
      <h1 className="font-display text-2xl font-extrabold text-foreground">Edit listing</h1>
      <div className="mt-6">
        <ListingForm initial={listing} onSubmit={update} submitLabel="Save changes" />
      </div>
    </div>
  );
}
